// Types
import {
  LayoutFooterBuilderHandlersType,
  LayoutFooterMethodsHandlersType,
} from './types/layout-footer.handlers.type';

const cancelApplicationLinkClickHandler = ({
  handleCancelApplicationLinkClickTracking,
  setShowModal,
}: LayoutFooterBuilderHandlersType): void => {
  handleCancelApplicationLinkClickTracking();
  setShowModal(true);
};

const closeCancelApplicationModalClickHandler = ({
  handleCloseCancelApplicationModalClickTracking,
  setShowModal,
}: LayoutFooterBuilderHandlersType): void => {
  handleCloseCancelApplicationModalClickTracking();
  setShowModal(false);
};

const LayoutFooterHandlers = (
  props: LayoutFooterBuilderHandlersType
): LayoutFooterMethodsHandlersType => ({
  handleCancelApplicationLinkClick: () => cancelApplicationLinkClickHandler(props),
  handleCloseCancelApplicationModalClick: () => closeCancelApplicationModalClickHandler(props),
});

export { LayoutFooterHandlers };
